<template>
  <div>
    <el-row>
      <el-row>
        <el-col :span="20">
          <el-form :model="searchForm" ref="searchForm" :inline="true">
            <el-form-item label="产品名称：">
              <el-input size="medium" v-model="searchForm.PRODUCT_NAME" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="日期范围：">
              <el-date-picker size="medium" v-model="searchForm.DAY" type="daterange" align="right" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button size="medium" type="primary" @click="querySearch">筛选</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-table :data="warehouseData" stripe border style="width: 100%">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="PRODUCT_NAME" label="产品" min-width="80"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位" min-width="70"></el-table-column>
            <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="70"></el-table-column>
            <el-table-column prop="BATCH" label="批次" min-width="70"></el-table-column>
            <el-table-column prop="PRODUCTION_DATE" label="生产日期" min-width="70"></el-table-column>
            <el-table-column label="保质期" min-width="70">
              <template slot-scope="scope">
                <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="PRODUCT_COUNT" label="库存数量" min-width="45"></el-table-column>
            <el-table-column prop="PRODUCT_WORTH" label="剩余价值" min-width="45"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="openContract(scope.row)">查看溯源</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-pagination style="float:right;" @current-change="handleCurrentChange" :current-page.sync="currentPage"
        :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="total_count">
      </el-pagination>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {},
      warehouseData: [],
      pageSize: 20,
      currentPage: 1,
      total_count: 0,
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.getList();
  },
  methods: {
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getList();
    },
    // 拉取产品
    getList() {
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 64,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.DAY) {
        params.START_DAY = this.searchForm.DAY[0];
        params.END_DAY = this.searchForm.DAY[1];
      }
      http.post(params).then((result) => {
        this.total_count = result[0].TOTAL;
        this.warehouseData = result[0].list;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySearch() {
      this.currentPage = 1;
      this.getList();
    },
    openContract(row) {
      sessionStorage.setItem('pro_name_T', row.PRODUCT_NAME);
      sessionStorage.setItem('pro_unit_T', row.TYPE_UNIT);
      this.$router.push({ path: `/tracingContract/${row.PRODUCT_CODE}/${row.BATCH}`, params: { id: row.PRODUCT_CODE, code: row.BATCH } });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tracing/productTracing.vue